import type { CategoryContent } from '../row.js';

export const FRENCH_HISTORY: CategoryContent = {
  bscba: [
    [
      'Welke Frankische dynastie, bekend om hun "langharige koningen", regeerde vóór de Karolingen?',
      [
        'De Merovingen',
        'De Visigotische dynastie',
        'De Ostrogotische dynastie',
        'De Vandaalse dynastie',
      ],
      0,
      'De Merovingen (481–751) waren de eerste Frankische dynastie, genoemd naar legendarische voorouder Merovech. Hun macht verzwakte naarmate de Paleismeesters sterker werden.',
    ],
    [
      'Wat was de betekenis van Karels de Grotes kroning op Eerste Kerstdag 800?',
      [
        'Hij werd gekroond tot Heilige Roomse Keizer',
        'Hij werd de eerste christelijke koning van Frankrijk',
        'Hij riep zichzelf uit tot Paus van de Westerse Kerk',
        'Hij veroverde Rome en stichtte een nieuwe religieuze hoofdstad',
      ],
      0,
      'Karels kroning door Paus Leo III stichtte het Heilige Roomse Rijk en symboliseerde de fusie van Frankische macht met pauselijke autoriteit in het Westen.',
    ],
    [
      'Welke dynastie, gesticht door Hugo Capet, maakte Parijs tot haar machtsbasis en domineerde Frankrijk geleidelijk?',
      [
        'De Kapetingen',
        'De Karolingische dynastie',
        'De Anjou-dynastie',
        'De Bourgondische dynastie',
      ],
      0,
      'De Kapetingen (987–1328) bouwden hun koninkrijk uit de Île-de-France en gebruikten feodale relaties en huwelijken om hun domein eeuwenlang uit te breiden.',
    ],
    [
      'Wat was de voornaamste oorzaak van de Honderdjarige Oorlog tussen Engeland en Frankrijk?',
      [
        'Engelse aanspraken op de Franse troon',
        'Franse invasie van Engelse grondgebieden in Brittannië',
        'Religieuze verschillen tussen Engelse katholieken en Franse protestanten',
        'Handelsdisputen over controle van Middellandse Zeehavens',
      ],
      0,
      'De Honderdjarige Oorlog (1337–1453) ontstond uit Engelse dynastieke aanspraken op Frankrijk, voortvloeiend uit de Normandische Verovering en Angevinse bezittingen.',
    ],
    [
      'Wie was Jeanne d\'Arc en wat was haar rol in de Honderdjarige Oorlog?',
      [
        'Een Franse boerenmeisje dat Franse troepen aanvoerde',
        'Een Engelse generaal die Franse legers bij Crécy versloeg',
        'Een Franse adelvrouw die vredesverdragen met Engeland onderhandelde',
        'Een Franse geleerde die militaire strategie aan de dauphin doceerde',
      ],
      0,
      'Jeanne d\'Arc (1412–1431) claimde goddelijke inspiratie, motiveerde Franse troepen, en zorgde voor de kroning van de dauphin. Zij werd later door de Engelsen terechtgesteld.',
    ],
    [
      'Welk stelsel van bestuur kenmerkte de regering van Lodewijk XIV?',
      [
        'Absolute monarchie, gecentraliseerd bij de koning',
        'Grondwettelijke monarchie met een machtig parlement',
        'Democratische republiek met gekozen functionarissen',
        'Feodale stelsel met machtige onafhankelijke edelen',
      ],
      0,
      'Lodewijk XIV (r. 1643–1715) belichaamde absolute monarchie. Hij centraliseerde macht, verplaatste het hof naar Versailles en verzwakte de onafhankelijkheid van adel.',
    ],
    [
      'Wat was het Edict van Nantes (1598) en wie beschermde het?',
      [
        'Hendrik IV\'s decreet van religieuze tolerantie voor hugenoten',
        'Lodewijk XIV\'s wet die alle protestantse kerken in Frankrijk verbood',
        'Een pauselijke bul die de autoriteit van de Paus in Frankrijk stelde',
        'Een feodale overeenkomst tussen de koning en Franse adel',
      ],
      0,
      'Het Edict van Nantes verleende hugenoten (Franse protestanten) religievrijheid en politieke rechten. Lodewijk XIV hief het in 1685 op, waarna de vervolgingen weer toenamen.',
    ],
    [
      'Welke gebeurtenis in 1789 wordt beschouwd als symbolisch begin van de Franse Revolutie?',
      [
        'De bestorming van de Bastille',
        'De executie van Koning Lodewijk XVI',
        'De Verklaring van de Rechten van de Mens',
        'De oproeping van de Staten-Generaal',
      ],
      0,
      'Op 14 juli 1789 stormden Parijzenaars de Bastille, symbool van koninklijke tirannie. De gebeurtenis markeert het begin van de Revolutie en is Frans nationale feestdag.',
    ],
    [
      'Welke periode zag snelle executies tijdens de Franse Revolutie, inclusief Koning Lodewijk XVI?',
      [
        'De Schrikbewind onder Robespierre',
        'De Directoire-periode van gematigde republikanisme',
        'Het Consulaat onder Napoleons leiderschap',
        'De Restauratie onder Lodewijk XVIII',
      ],
      0,
      'De Schrikbewind (1793–1794) onder Maximiliaan Robespierre zag massale guillotine-executies, onder wie Lodewijk XVI, Marie Antoinette en duizenden tegenstanders van de Revolutie.',
    ],
    [
      'Hoe steeg Napoleon Bonaparte naar de macht in Frankrijk?',
      [
        'Via de Coup van 18 Brumaire in 1799',
        'Door democratisch verkozen te worden tot president',
        'Door de troon te erven van Koning Lodewijk XVI',
        'Door een populaire boerenopstand tegen adel aan te voeren',
      ],
      0,
      'De Coup van 18 Brumaire (9 november 1799) bracht Napoleon aan de macht als Consul. Hij profiteerde van de onpopulariteit en zwakte van het Directoire, dat midden in een oorlog en economische crisis zat.',
    ],
    [
      'Wat was het voornaamste doel van het Napoleonisch Wetboek dat in 1804 werd ingevoerd?',
      [
        'Het invoeren van uniform Frans burgerlijk recht',
        'Het bevestigen van absolute macht van de Katholieke Kerk in alle juridische aangelegenheden',
        'Het herstellen van feodale privileges voor Franse adel',
        'Het stellen van een onafhankelijk wetgevend lichaam los van het bestuur',
      ],
      0,
      'Het Napoleonisch Wetboek standaardiseerde Frans recht en verving een lappendeken van feodale gewoontes. Het beïnvloedde rechtsstelsels in heel Europa en benadrukte wereldse burgerrechten.',
    ],
    [
      'Hoe reageerde het Congres van Wenen (1814–1815) op Napoleons nederlaag?',
      [
        'Het herstelde de Bourbonische monarchie onder Lodewijk XVIII',
        'Het elimineerde Frankrijk volledig en verdeelde zijn grondgebied onder buurlanden',
        'Het stichtte een democratische republiek in heel Europa',
        'Het benoemde Napoleons zoon tot regent van een verzwakt Frankrijk',
      ],
      0,
      'Het Congres van Wenen herstelde de Bourbonische monarchie en machtsevenwicht in Europa. Frankrijk werd tot zijn grenzen van 1789 teruggebracht maar bleef een grootmacht.',
    ],
    [
      'Wat was de uitkomst van de Revolutie van 1848 in Frankrijk?',
      [
        'Het stichtte de Tweede Republiek en breidde stemrecht uit',
        'Het beëindigde permanent de Franse monarchie en stelde democratisch bestuur in',
        'Het leidde tot onmiddellijke eenmaking van alle Europese staten',
        'Het herstelde de Bourbondynastie tot absolute macht',
      ],
      0,
      'De Revolutie van 1848 creëerde de Tweede Republiek, breidde het stemrecht uit en schafte de slavernij af. De republiek was echter kortstondig: Napoleon III greep in 1852 de macht.',
    ],
    [
      'Welke Franse staatsman en militaire held leidde de Vrije Franse verzet tijdens Wereldoorlog II?',
      [
        'Charles de Gaulle',
        'Pierre Laval',
        'Philippe Pétain',
        'Jean Monnet',
      ],
      0,
      'Charles de Gaulle (1890–1970) organiseerde de Vrije Franse troepen, verzette zich tegen het Vichy-regime en leidde Frankrijk na de bevrijding. Later stichtte hij de Vijfde Republiek.',
    ],
    [
      'Welk stelsel van bestuur werd ingesteld door de Vijfde Republiek-grondwet in 1958?',
      [
        'Een semi-presidentieel stelsel met gekozen president',
        'Een absolute monarchie met enkel ceremoniële bevoegdheden',
        'Een zuivere parlementaire democratie zonder apart bestuur',
        'Een militaire dictatuur onder rechtstreeks bevel van de Gaulle',
      ],
      0,
      'De Vijfde Republiek (1958–heden) schiep een semi-presidentieel stelsel dat presidentiële en parlementaire macht in balans houdt. Het is nog steeds Frans grondwettelijk kader.',
    ],
  ],
  msc: [
    [
      'Welke Merovingische praktijk, waarbij het koninkrijk gelijk onder de zonen werd verdeeld, schiep instabiliteit en regionale fragmentatie?',
      [
        'Deelbare erfenis, die het koninkrijk onder erfgenamen verdeelde',
        'Eerstgeboorterecht, dat alle rijkdom op de eerstgeborene concentreerde',
        'Matrilineale opvolging, die macht bij vrouwelijke regentes legde',
        'Electieve monarchie, die voortdurend strijd tussen edelen vereiste',
      ],
      0,
      'Deelbare erfenis betekende dat vorstendommen onder erfgenamen werden verdeeld, waardoor Austrasië, Neustrië en Aquitanië ontstonden. Deze fragmentatie stelde de Paleismeesters in staat macht te concentreren door opvolgingsruzies te manipuleren.',
    ],
    [
      'Welke militaire innovatie gebruikte Pepin III om Lombardijen te verslaan en pauselijke alliantie veilig te stellen?',
      [
        'Zware cavalerie met stijgbeugels domineerde het slagveld',
        'Marine-eskaders die Middellandse Zeeroutes naar Byzantijnse gebieden controleerden',
        'Grieks vuur-technologie, aangenomen uit Byzantijnse bronnen, voor belegeringsoorlogvoering',
        'Olifanten geïmporteerd uit Noord-Afrika voor psychologisch effect tegen vijanden',
      ],
      0,
      'Pepin III (Pepin de Korte) zette zware cavalerie met stijgbeugels in en revolutioneerde daarmee de Frankische oorlogvoering. Zijn overwinningen op Lombardije wonnen hem pauselijke dankbaarheid en legitimeerden zijn dynastie.',
    ],
    [
      'Welk onderwijs- en cultuurprogramma implementeerde Karel de Grote om zijn rijk te versterken?',
      [
        'De Karolingische Renaissance, klassiek leren herlevend',
        'Een stelsel van wereldse universiteiten die Griekse filosofie en retorica doceerden',
        'Verplichte militaire academies voor training van adellijke officieren',
        'Handwerkscholen die kooplieden geavanceerde boekhouding en navigatie onderwezen',
      ],
      0,
      'Karels Karolingische Renaissance herstelde klassieke teksten, standaardiseerde het Latijnse schrift (het Karolingisch minuskel) en bevorderde alfabetisering onder de geestelijkheid. Deze culturele heropleving beïnvloedde middeleeuws Europa.',
    ],
    [
      'Hoe beïnvloedde het Verdrag van Verdun (843) de structuur en erfenis van het Karolingische Rijk?',
      [
        'Het verdeelde het rijk in drie koninkrijken',
        'Het verenigde alle Frankische territoria onder rechtstreeks bewind van één erfgenaam',
        'Het overdroeg keizerlijke autoriteit volledig aan Byzantijnse Keizer',
        'Het schaffte feodalisme af en stelde rechtstreeks koninklijk bestuur over alle regio\'s in',
      ],
      0,
      'Verdun verdeelde Karels rijk onder zijn kleinzonen. De deling creëerde proto-Frankrijk, proto-Duitsland en een omstreden middenrijk, en legde daarmee de basisstructuur van de Europese politiek vast.',
    ],
    [
      'Welke feodale strategie gebruikte Filips Augustus (r. 1180–1223) om Kapetingisch domein ten koste van Anjou uit te breiden?',
      [
        'Hij gebruikte Jans zwakte om Normandische en Angevinse landen in beslag te nemen',
        'Hij kocht Engelse territoria van opeenvolgende bankrotte Engelse koningen',
        'Hij huwde de dochter van de Engelse koning om Engelse troon voor zijn erfgenamen op te eisen',
        'Hij onderhandelde handelsovereenkomsten die Engelse kooplieden van Franse havens isoleerden',
      ],
      0,
      'Filips Augustus profiteerde van Jans onpopulariteit en het verlies van Normandië. Voor 1202 had Filips de meeste Angevinse bezittingen in Frankrijk veroverd en zo het Kapetingische grondgebied verdrievoudigd.',
    ],
    [
      'Welk religieus conflict besprak de Albigense Kruistocht (1209–1229) in Zuid-Frankrijk?',
      [
        'Een kruistocht tegen Cathare ketters in Occitanië',
        'Een conflict tussen Franse katholieken en Moslimindringers uit Noord-Afrika',
        'Een burgeroorlog tussen rivaliserende Kapetingische erfgenamen om de troon',
        'Een opstand van zuidelijke adelen tegen Noord-Franse belastingen',
      ],
      0,
      'De Albigense Kruistocht vernietigde Cathare ketterij in Languedoc en bracht welgestelde zuidelijke territoria onder rechtstreeks Kapetingisch bestuur. De Inquisitie consolideerde katholieke ortodoxie.',
    ],
    [
      'Welke rol speelde Jeanne d\'Arc\'s proces en executie in Engelse politieke legitimiteit?',
      [
        'Haar veroordeling door een pro-Engels hof werd een verzet-symbool',
        'Haar executie demoraleerde permanent de Fransen en garandeerde Engels overwinning in de Honderdjarige Oorlog',
        'Haar proces stelde Engelse juridische autoriteit over Franse kerkelijke aangelegenheden in',
        'Haar executie verenigde Engelse en Franse kerken onder pauselijke controle',
      ],
      0,
      'Jeanne werd in 1431 wegens ketterij door een pro-Engels hof berecht en verbrand. Haar martelaarschap, later door Frankrijk gebruikt, symboliseerde Engelse onderdrukking en droeg bij aan het Engelse verlies.',
    ],
    [
      'Hoe weerspiegelden de Godsdienstoorlogen (1562–1598) conflicten voorbij zuivere sectaire doctrine?',
      [
        'Ze betroffen factiestrijd tussen Guise- en Bourbonfamilies',
        'Ze waren zuiver theologische debatten over schriftinterpretatie zonder politieke dimensie',
        'Ze waren burgeroorlogen tussen boeren en adel over landherverdeling',
        'Ze waren buitenlandse invasies door Spaanse en Italiaanse katholieke legers naar territoriaal verovering',
      ],
      0,
      'Bij de Godsdienstoorlogen speelden dynastieke rivaliteit, adellijke factiestrijd en buitenlandse inmenging een rol, waarbij protestantisme en katholicisme eerder als banieren voor politieke rivaliteit dienden dan als enige oorzaak.',
    ],
    [
      'Welk economisch beleid implementeerde Jean-Baptiste Colbert om Frankrijk onder Lodewijk XIV te versterken?',
      [
        'Mercantilisme: vervaardiging bevorderen en bullion accumuleren',
        'Vrij handelen met alle Europese naties en koloniale territoria',
        'Feodale landbouwgemeenschappen zonder centrale fiscale controle',
        'Rechtstreeks staatseigendom van alle koopvaardijschepen en handelsmaatschappijen',
      ],
      0,
      'Colberts mercantilisme stimuleerde de Franse nijverheid, bouwde de marine uit, charterde handelsmaatschappijen en genereerde koninklijke inkomsten via tarieven en koloniale handelsmonopolies.',
    ],
    [
      'Welke rol speelde het Parlement van Parijs (juridisch lichaam, geen legislatuur) bij oppositie tegen 18e-eeuwse fiscale hervorming?',
      [
        'Het blokkeerde belastinghervormingen door edicten niet te registreren',
        'Het steunde de kroon door alle voorgestelde fiscale maatregelen in te voeren',
        'Het probeerde democratisch stemrecht voor alle Franse onderdanen in te stellen',
        'Het sloot zich aan bij buitenlandse mogendheden om Franse staatsconsolidatie te voorkomen',
      ],
      0,
      'Het Parlement van Parijs blokkeerde fiscale edicten door registratie te weigeren. Deze juridische obstructie door bevoorrechte parlementariërs vertraagde noodzakelijke hervormingen en verdiepte de fiscale crisis.',
    ],
    [
      'Hoe beïnvloedden verlichtingsfilosofieën, met name van Diderot en Rousseau, de Franse Revolutionaire ideologie?',
      [
        'Ze bevorderden rationele kritiek op de monarchie en volkssoevereiniteit',
        'Ze verdedigden feodalisme en adellijk privilege als natuurlijk en door God gegeven',
        'Ze pleitten voor een sterkere centrale monarchie en uitgebreide koninklijke autoriteit',
        'Ze wezen alle vormen van sociale organisatie af als inherent corrupt',
      ],
      0,
      'Verlichtingsdenkers bekritiseerden willekeurige autoriteit, bevorderden rede en individuele rechten, en theoretiseerden over volkssoevereiniteit. Deze ideeën inspireerden rechtstreeks de Revolutionaire eisen van vrijheid en gelijkheid.',
    ],
    [
      'Welke transformatie trachtte de Civiele Constitutie van de Geestelijkheid (1790), en welke tegenstand lokte het uit?',
      [
        'Het onderwierp de Kerk aan staatsautoriteit, wat een pauselijk schisma uitlokte',
        'Het verleende Kerk onbeperkte controle over staatsbelastingen en juridische autoriteit',
        'Het schaffte alle religieuze instellingen af en converteerde kerken naar openbare pakhuizen',
        'Het herstelde feodale kerkgoederen en versterkte pauselijke autoriteit over Frankrijk',
      ],
      0,
      'De Civiele Constitutie maakte geestelijken tot staatsambtenaren en onderwierp de Kerk aan de staat. Paus Pius VI veroordeelde haar, wat de Franse katholieken verdeelde en tegenrevolutionaire bewegingen voedde.',
    ],
    [
      'Hoe markeerde de Thermidoriaanse Reactie (juli 1794) een keerpunt in de Revolutie?',
      [
        'Het executeerde Robespierre en beëindigde het Schrikbewind',
        'Het verstevigde radicaal Jacobijn controle en versnelde executies',
        'Het herstelde Bourbonische monarchie tot absolute macht onmiddellijk',
        'Het stelde democratisch socialisme als Frans bestuurideologie in',
      ],
      0,
      'De val van Robespierre op 9 Thermidor beëindigde de Schrikbewind. De Thermidorianen stelden een meer gematigde, op eigendom gebaseerde republiek in, wat de weg voor Napoleon vrijmaakte.',
    ],
    [
      'Met welke militaire crisis kreeg het Directoire te maken vlak voor Napoleons coup in 1799?',
      [
        'Militaire verliezen en royalistische opstanden destabiliseerden de Republiek',
        'Napoleon stapte vrijwillig naar voren om een buitenlandse monarchie in Frankrijk af te houden',
        'Het Directoire zocht uitbreiding van de democratie via een militaire revolutionaire raad',
        'Groot-Brittannië versloeg de Franse vloot beslissend, waardoor Napoleon defensief moest handelen',
      ],
      0,
      'Het Directoire kampte met militaire nederlagen, een financiële instorting, een royalistische opleving en de dreiging van buitenlandse invasie. Deze crises ondermijnden de legitimiteit van het burgerlijke bestuur en maakten Napoleons machtsovername mogelijk.',
    ],
    [
      'Hoe demonstreerden de Honderd Dagen (maart–juni 1815) Napoleons blijvend appel en zijn grenzen?',
      [
        'Hij motiveerde loyale legers maar verloor beslissend bij Waterloo',
        'Hij veroverde Europa met succes en stelde permanente dynastie in',
        'Hij abdikeerde vrijwillig om Bourbons zonder militair gevecht te herstellen',
        'Hij werd onmiddellijk gearresteerd en geëxecuteerd na zijn ontsnapping',
      ],
      0,
      'Soldaten verzamelden zich in 1815 rond Napoleons banier, wat zijn populariteit aantoonde. Europese legers versloegen hem echter bij Waterloo, wat liet zien dat zijn persoonlijke magnetisme niet opgewassen was tegen de macht van een coalitie.',
    ],
  ],
  phd: [
    [
      'Wat onderscheidde de Austrasische hegemonie van de Neustrische politieke structuren in de vroege Merovingische periode, en wat dreef hun rivaliteit?',
      [
        'De Austrasische militaire aristocratie botste met de Neustrische hofelite om controle over de koning',
        'Austrasië was een Romeinse provincie, terwijl Neustrië volledig Germaans was en geen institutionele structuren had',
        'Neustrië bezat altijd meer rijkdom, terwijl Austrasië puur op militaire verovering leunde',
        'Ze beleden fundamenteel verschillende religies: Austrasië was heidens en Neustrië katholiek',
      ],
      0,
      'Austrasische en Neustrische edelen streden om controle over de zwakke Merovingische koningen. Dit factionalisme fragmenteerde het koninkrijk en stelde de Paleismeesters — oorspronkelijk Austrasische ambtenaren — in staat macht te consolideren.',
    ],
    [
      'Hoe vestigden Pepin III\'s introductie van zware cavalerietactiek en het feodale leenstelsel de Karolingische militaire suprematie?',
      [
        'Bereden ridders met stijgbeugels en feodale verplichtingen schiepen een superieur leger',
        'Pepin vond de katapult en het buskruit uit, wat technologische dominantie vestigde',
        'Hij trainde uitsluitend boerenlegers door middel van dienstplicht en massamobilisatie',
        'Hij leunde voor al zijn militaire campagnes volledig op Byzantijnse huurlingen',
      ],
      0,
      'Pepins zware cavalerie steunde op stijgbeugels, wat schoktactieken mogelijk maakte. Het feodale stelsel verplichtte edelen als vazallen tot militaire dienst, waardoor een gedecentraliseerde maar gecoördineerde krijgersklasse ontstond.',
    ],
    [
      'Welke pedagogische hervormingen in de Karolingische Renaissance, met name Karels Admonitio Generalis, transformeerden de alfabetisering en de intellectuele cultuur?',
      [
        'Standaardisering van het schrift, alfabetisering in kloosters en hervorming van het geestelijk onderwijs',
        'Hij schafte het Latijn af en bevorderde alleen Germaanse talen voor het bestuur',
        'Hij sloot alle kloosters en richtte uitsluitend seculiere universiteiten voor de adel op',
        'Hij legde één Latijns dialect op, waardoor regionale taalvariatie verdween',
      ],
      0,
      'Karels edict standaardiseerde het schrift, verplichtte kloosters tot onderwijs en zorgde voor de correctie van klassieke teksten. Het Karolingisch minuskel maakte kopiëren en lezen gemakkelijker — een ware informatietechnologische revolutie.',
    ],
    [
      'Hoe bereikten Kapetingische feodale strategieën, met name huwelijksallianties en systematisch procederen tegen vazallen, dominantie zonder aanvankelijk over superieure militaire kracht te beschikken?',
      [
        'Via huwelijken die grote leengoederen opleverden en via kerkelijke rechtbanken tegen rivalen',
        'Via militaire campagnes die alle gebieden in één generatie veroverden',
        'Via koopmansrijkdom waarmee alle grond werd opgekocht',
        'Via verplichte religieuze bekering om loyaliteit te consolideren',
      ],
      0,
      'De Kapetingers breidden hun macht uit via strategische huwelijken (waarmee ze onder meer Aquitanië en Bretagne wonnen), door vazallenrecht te gebruiken om magnaten uit te dagen, en via kerkelijke allianties. Militaire verovering kwam pas later, na de politieke consolidatie.',
    ],
    [
      'Welke structurele zwakheid in het Angevinse erfenisstelsel gebruikte Filips Augustus om de Engelse bezittingen in Frankrijk te fragmenteren?',
      [
        'De opstand van Jans baronnen stelde Filips in staat diens landen in beslag te nemen',
        'De Angevinse erfenis was te welvarend om effectief te verdedigen',
        'Engelse baronnen droegen hun Franse grondgebied vrijwillig over aan de Kapetingische kroon',
        'Een verdrag droeg Angevinse bezittingen automatisch over aan de Kapetingische lijn',
      ],
      0,
      'Jans onpopulariteit, zijn conflict met de Engelse baronnen en zijn militaire onbekwaamheid schiepen kansen. Filips maakte van deze verdeeldheid gebruik en nam Normandië, Anjou en Maine op grond van het feodale recht in beslag.',
    ],
    [
      'Hoe beïnvloedde de integratie van de bedelmonnikenorden in de hofcultuur en intellectuele netwerken het laatmiddeleeuwse Kapetingische bestuur?',
      [
        'Dominicanen en Franciscanen werden koninklijke adviseurs en pauselijke belangenbehartigers',
        'Ze scheidden geestelijke en wereldlijke autoriteit volledig en weigerden politieke betrokkenheid',
        'Ze elimineerden het Benedictijnse monasticisme en consolideerden alle religieuze autoriteit in Rome',
        'Ze stelden onafhankelijke gemeenschappen in die de koninklijke jurisdictie beperkten',
      ],
      0,
      'Bedelmonniken werden biechtvaders, theologen en politieke adviseurs van koningen. Ze verbonden pauselijke autoriteit met koninklijke legitimiteit, terwijl ze tegelijk onderwijs en doctrinaire orthodoxie bevorderden.',
    ],
    [
      'Welke rol speelde de Salische-wetdoctrine bij het legitimeren van de Valois-opvolging en het uitsluiten van de Engelse aanspraak na 1328?',
      [
        'Franse juristen riepen de Salische wet aan om de Engelse aanspraak uit te sluiten',
        'De Salische wet werd in de 14e eeuw uitgevonden om Engelse aanspraken op Frankrijk te ondersteunen',
        'Het was een Romeins rechtsprincipe zonder verband met de middeleeuwse opvolging',
        'Het stelde een mannelijke electieve monarchie in plaats van erfelijke opvolging in',
      ],
      0,
      'Na 1328 gebruikten Franse juristen de Salische wet om de aanspraak van Edward III (via afstamming langs moederszijde) uit te sluiten. Deze doctrine werd een grondslag voor de Franse nationale identiteit en legitimeerde de Valois-heerschappij.',
    ],
    [
      'Hoe vormde de factiestrijd tijdens de Fronde (1648–1653) — tussen kroon, Parlement en adel — het koninklijk absolutisme?',
      [
        'De Fronde stelde Lodewijk XIV in staat macht te centraliseren en de adel te ontwapenen',
        'De Fronde voerde met succes een parlementaire democratie in en beperkte de koninklijke autoriteit blijvend',
        'De Fronde was een boerenopstand zonder invloed op de elitaire machtsstructuur',
        'Het resulteerde in het onmiddellijke herstel van feodale onafhankelijkheid voor regionale edelen',
      ],
      0,
      'De Fronde toonde de kroon dat adel en Parlement een existentiële bedreiging vormden. Lodewijk XIV\'s reactie was berekende centralisatie: hij verplaatste het hof naar Versailles om de magnaten onder toezicht te houden en te ontwapenen.',
    ],
    [
      'Welke fiscale mechanismen — belastingpacht, ambtsvenaliteit, inflatie — schiepen de structurele tekorten die de laat-18e-eeuwse monarchie destabiliseerden?',
      [
        'Belastingpacht en venale ambten schiepen chronische tekorten',
        'De monarchie besteedde opzettelijk geld om de adel te verzwakken',
        'Frankrijk had geen werkelijke fiscale crisis; de Revolutie was zuiver ideologisch',
        'Buitenlandse leningen namen alle druk op de Franse staatsfinanciën weg',
      ],
      0,
      'Belastingpacht verrijkte financiers, niet de kroon. Venale ambten verslonden kapitaal. Inflatie verlaagde het reële inkomen terwijl de uitgaven stegen. Deze structurele tekorten maakten de monarchie tegen 1789 vrijwel insolvent.',
    ],
    [
      'Hoe belichaamde de parlementaire tegenstand tegen koninklijke edicten — met name de Maupeou-hervormingen (1768–1774) — rivaliserende opvattingen over soevereiniteit?',
      [
        'Parlementen riepen oude grondwettelijke rechten tegen de monarchie aan',
        'Parlementen waren de enige legitieme autoriteit en wisten koninklijke hervormingen altijd af te weren',
        'De Maupeou-hervormingen waren voorbijgaand en hadden geen blijvende impact',
        'Parlementen en de kroon werkten altijd zonder conflict samen',
      ],
      0,
      'Parlementen gebruikten het middel van "remonstrantie" om zich tegen edicten te verzetten, met het argument dat zij "Frankrijks oude grondwet" vertegenwoordigden. Maupeou verbande hen en claimde daarmee absolute soevereiniteit. Hun terugkeer in 1774 liet de grenzen van het absolutisme zien.',
    ],
    [
      'Hoe beïnvloedde de fysiocratische theorie — die stelde dat land de enige bron van rijkdom was en één enkele belasting voorstelde — het fiscale debat vóór de Revolutie?',
      [
        'Fysiocraten daagden handelsprivileges uit maar vervreemdden de financiers van zich',
        'Fysiocraten voerden hun stelsel met succes in en elimineerden alle tekorten',
        'Ze hadden geen invloed op het 18e-eeuwse denken en werden volledig verworpen',
        'Hun theorie verstevigde de belastingpacht en venale ambten',
      ],
      0,
      'Turgot en Necker riepen fysiocratische ideeën aan om belastingpacht en monopolies aan te vallen. De fysiocratische voorstellen bedreigden gevestigde financiële belangen, wat een tegenreactie uitlokte die de hervormingspogingen verzwakte.',
    ],
    [
      'Welke grondwettelijke ambiguïteit en geestelijke tegenstand tegen de Civiele Constitutie van de Geestelijkheid zorgden na 1791 voor tegenrevolutionaire rekrutering?',
      [
        'Niet-eedige priesters werden verzetssymbolen in het westen',
        'Alle geestelijken omarmden de Civiele Constitutie enthousiast, zonder enige tegenstand',
        'Het had geen religieuze dimensie en was een zuiver fiscale maatregel',
        'De Constitutie verenigde alle geestelijken achter de Revolutionaire regering',
      ],
      0,
      'De Civiele Constitutie splitste de geestelijkheid in "constitutionele" en "niet-eedige" facties. Dit schisma stelde conservatieve organisatoren in staat katholieken rond religieuze grieven te mobiliseren, wat de Vendéeopstand voedde.',
    ],
    [
      'Hoe rechtvaardigde Robespierres Comité voor Publieke Veiligheid de escalerende terreur via het discours over "deugd" en de algemene wil?',
      [
        'Robespierre zag terreur als noodzakelijk voor de volkswil',
        'Robespierre was volledig tegen terreur en werkte aan het voorkomen van executies',
        'Het Comité gebruikte terreur zonder ideologische rechtvaardiging',
        'Robespierre onderschreef het klassieke liberalisme en onvoorwaardelijke individuele rechten',
      ],
      0,
      'Robespierre versmolt Rousseaus idee van de volkswil met terreur: vijanden van het volk stonden deugd in de weg, en hun eliminatie zuiverde de Republiek. Deze ideologie rechtvaardigde ongekend geweld als moreel handelen.',
    ],
    [
      'Welke rol speelde massale conscriptie (levée en masse, 1793) in de Revolutionaire en Napoleontische militaire dominantie, en hoe transformeerde het de oorlogvoering?',
      [
        'Het schiep enorme legers die professionele troepen overweldigden',
        'Massale conscriptie was onpopulair en werd nooit werkelijk geïmplementeerd',
        'Het werd uitsluitend bij de marine gebruikt en had geen effect op de oorlogvoering te land',
        'Andere Europese naties hadden al eerder grotere conscriptieprogramma\'s ingevoerd',
      ],
      0,
      'De levée en masse mobiliseerde hele bevolkingen als soldaten. Revolutionaire en Napoleontische legers telden 200.000 tot 400.000 man, veel meer dan traditionele legers. Deze transformatie maakte Frankrijk twee decennia lang militair dominant.',
    ],
    [
      'Hoe hervormde Napoleons Continentaal Stelsel — de Britse handelsblokkade — de Europese economische integratie, en hoe leidde het uiteindelijk tot verzet tegen de Franse dominantie?',
      [
        'Het verrijkte Franse fabrikanten maar verarmde de bondgenoten',
        'Het Continentaal Stelsel elimineerde alle internationale handel permanent',
        'Het werd universeel geprezen en verstevigde de Franse allianties',
        'Groot-Brittannië werd economisch verwoest, wat leidde tot de capitulatie van Frankrijk',
      ],
      0,
      'Het Continentaal Stelsel onderwierp de economieën van de bondgenoten aan de Franse belangen. De economische ontberingen in bezette gebieden wekten nationalisme en wrok op, wat Napoleons coalitievorming verzwakte.',
    ],
  ],
  professor: [
    [
      'Hoe institutionaliseerden de compositiones (Merovingische regels voor de verdeling van erfenissen) een politiek stelsel dat de centrale autoriteit paradoxaal genoeg verzwakte, terwijl het tegelijk de voorloper van de latere feodale hiërarchie vestigde?',
      [
        'De compositiones stelden ambtenaren in staat macht over te nemen van zwakke koningen',
        'De compositiones schaften erfenis volledig af en installeerden gekozen heersers',
        'Ze verstevigden de centrale monarchie door alle macht bij één erfgenaam te concentreren',
        'Ze waren uit Rome geïmporteerd en hadden niets te maken met het Frankische gewoonterecht',
      ],
      0,
      'De compositiones regelden de verdeling onder erfgenamen, maar schiepen machtsvacuüms. De Paleismeesters maakten gebruik van de verdeelde opvolgingsstrijd en hun administratieve controle om zich te transformeren van paleisambtenaren tot quasi-soevereine magnaten.',
    ],
    [
      'In welke mate beperkte de vroeg-Karolingische fiscale crisis — voortvloeiend uit dalende belastinginkomsten en monetariseringsproblemen — de militaire uitbreidingsmogelijkheden van Pepin III en Karel de Grote?',
      [
        'Fiscale tekorten dwongen tot herverdeling van kerkgronden als leengoed',
        'Ze hadden onbeperkte geldmiddelen en kregen nooit met fiscale beperkingen te maken',
        'Fiscaal beleid was irrelevant voor militaire mogelijkheden of de vorming van het feodalisme',
        'De Kerk financierde alle militaire campagnes via tienden en vrijwillige giften',
      ],
      0,
      'Pepin pakte de fiscale crisis aan door kerkgrond te seculariseren en aan loyale volgelingen te schenken, en bond zo krijgers via grondschenking en vazalschap aan de kroon — een protofeodale innovatie.',
    ],
    [
      'Hoe ging de laat-7e-eeuwse Neustrische hegemonie onder de Paleismeesters (met name de Pippinidische clan) vooraf aan de transformatie van administratief ambt naar politieke dynastie?',
      [
        'De Paleismeesters zetten hun erfelijke ambt en controle over de schatkist om in dynastieke macht',
        'De Paleismeesters waren voorbijgaande ambtenaren zonder de mogelijkheid om macht op te bouwen of een dynastie te stichten',
        'Administratieve ambten waren altijd gescheiden van politieke macht',
        'De Pippinieden bekleedden nooit een ambt en hadden geen rol in het Merovingische bestuur',
      ],
      0,
      'De Paleismeesters gebruikten hun controle over het koninklijke huishouden om patronagenetwerken op te bouwen, land en ambten te verdelen en aanspraak op erfelijke dynastievorming te vestigen. Deze transformatie van ambt naar dynastie ging vooraf aan het feodalisme.',
    ],
    [
      'Welk historiografisch debat gaat over de vraag of de Benedictijnse kloosterhervorming (Cluny, later Cîteaux) de wereldlijke autoriteit van de Kapetingers in de 11e tot 13e eeuw versterkte of juist beperkte?',
      [
        'Geleerden debatteren of de kloosterhervorming de koninklijke legitimiteit versterkte of juist verzwakte',
        'Alle kloosters waren in alle tijdsperioden volledig aan de kroon onderworpen',
        'Kloosters en wereldlijke heersers hadden geen enkele interactie',
        'De Benedictijnse hervorming was een zuiver geestelijke beweging zonder politieke implicaties',
      ],
      0,
      'Cluny en Cîteaux verwierven uitzonderingen op de lokale jurisdictie, wat de Kapetingische controle verzwakte. Toch kocht koninklijke steun voor de hervorming ook legitimiteit. Het gevolg was gemengd: de kerkelijke macht groeide, terwijl de Kapetingers aan prestige wonnen.',
    ],
    [
      'Hoe onthulde de Kapetingische huwelijksstrategie — Eleonore van Aquitanië trouwde eerst met Lodewijk VII, daarna met Hendrik II van Engeland, wat tot Angevinse controle over haar gebied leidde — de dynastieke kwetsbaarheid die de Honderdjarige Oorlog voorspelde?',
      [
        'Eleonores huwelijk bracht Aquitanië naar de Angevijnen.',
        'Eleonores huwelijken hadden geen enkele politieke betekenis',
        'De huwelijken verenigden Frankrijk blijvend en zonder conflict',
        'Eleonore was nooit betrokken bij politieke huwelijken of bestuur',
      ],
      0,
      'Eleonore bracht Aquitanië eerst bij Lodewijk, en droeg het vervolgens over aan het Angevinse rijk van Hendrik II. Haar huwelijken verstevigden paradoxaal genoeg het Kapetingische prestige, terwijl ze tegelijk de Angevinse rivaal schiepen die hen drie eeuwen lang zou dwarsbomen.',
    ],
    [
      'In welke mate hervormden de intellectuele onafhankelijkheid en het stedelijke prediken van de bedelmonnikenorden de pauselijke autoriteit en de wereldlijke koninklijke ideologie in de 13e eeuw?',
      [
        'Bedelmonniken werden tussenpersonen tussen de paus en koningen',
        'Bedelmonniken waren volledig ondergeschikt aan de lokale bisschoppen en hadden geen onafhankelijke rol',
        'Ze verwierpen de pauselijke autoriteit volledig en verdedigden een revolutionaire democratie',
        'Ze hadden geen enkele band met het stedelijke leven of met prediken onder het volk',
      ],
      0,
      'Dominicanen dienden de pauselijke belangen via de inquisitie, terwijl Franciscanen de nadruk legden op evangelische armoede. Beide ordes verankerden de pauselijke autoriteit in de religieuze praktijk van leken, terwijl ze ook theologische legitimiteit verschaften aan koninklijke aanspraken op uitgebreidere jurisdictie.',
    ],
    [
      'Hoe construeerde de Valois-legitimiteitsdoctrine — de Salische wet, de afstamming van Filips III en de symbolische afwijzing van de Engelse "usurpatie" — een protonationalistische Franse identiteit die de dynastieke bijzonderheid oversteeg?',
      [
        'Valois-juristen gebruikten de Salische wet tegen de Engelse aanspraken',
        'Nationale identiteit bestond al vóór de Valois en had geen enkele band met hen',
        'De Salische wet was universeel aanvaard en speelde geen enkele rol in het legitimiteitsgeschil',
        'De Valois hadden geen bijzondere band met de Franse identiteit of enige aanspraak op legitimiteit',
      ],
      0,
      'Valois-juristen buitten de Salische wet uit, gingen voorbij aan voorouderlijke aanspraken en speelden in op anti-Engels sentiment om te betogen dat "Frankrijk" een erfelijke entiteit was. Dit nationalisme overleefde uiteindelijk het uitsterven van de dynastie: de natie overleefde haar koningen.',
    ],
    [
      'Hoe onthulde de aristocratische factiestrijd van de Fronde — vermomd in feodale eerbetoonsrelaties en parlementaire grondwettelijke aanspraken — de ideologische tegenstrijdigheden tussen absolute monarchie en adellijk privilege?',
      [
        'Frondeurs verzetten zich tegen centralisatie maar faalden.',
        'De Fronde stelde met succes een democratisch bestuur in',
        'Er waren geen tegenstrijdigheden tussen absolutisme en adellijk privilege',
        'De Fronde was een zuivere boerenopstand',
      ],
      0,
      'Frondeurs gebruikten feodale taal en parlementair-grondwettelijke argumenten om zich te verzetten tegen de centralisatie onder Lodewijk XIV. Hun onderdrukking toonde aan dat absolutisme de vernietiging van feodale wederkerigheid en juridisch pluralisme vereiste.',
    ],
    [
      'In welke mate vertegenwoordigde het intendantenstelsel — dat de directe autoriteit van de kroon centraliseerde en de autoriteit van de adel omzeilde — een verschuiving van feodaal personalisme naar rationeel-juridische autoriteit?',
      [
        'Salarisambtenaren vervingen erfelijke ambtsdragers.',
        'Intendanten waren feodale vazallen zonder nieuwe kenmerken ten opzichte van eerdere ambtenaren',
        'Ze hadden geen invloed op het bestuur of de administratieve structuur',
        'Het intendantenstelsel verstevigde de feodale onafhankelijkheid van de adel',
      ],
      0,
      'Intendanten vervingen venale, erfelijke ambten door benoemingen op salarisbasis. Deze verschuiving van feodale naar rationele bureaucratie maakte een ongekende centralisatie van de staat mogelijk en verdrong de administratieve autoriteit van de adel.',
    ],
    [
      'Hoe structureerden rivaliserende economische theorieën — de fysiocratische nadruk op grondrijkdom tegenover de mercantilistische nadruk op handel en nijverheid — de ideologische strijd rond fiscale hervorming in de laat-18e-eeuwse hofpolitiek?',
      [
        'Fysiocraten verzetten zich tegen belastingpacht en gilden.',
        'Fysiocratische en mercantilistische economen waren het volledig eens',
        'Economische theorie had geen werkelijke invloed op politieke hervorming',
        'Het hof had geen belangstelling voor abstract economisch debat',
      ],
      0,
      'Fysiocraten vertegenwoordigden grondrijkdom en vielen financiers aan; mercantilisten verdedigden gildemonopolies en bevoordeelden kooplieden. Hervormingspogingen kregen te maken met gecoördineerd verzet, omdat fiscale veranderingen meerdere elitebelangen tegelijk bedreigden.',
    ],
    [
      'Welk historiografisch debat omringt de relatie tussen het Gallicanisme en de Franse soevereiniteit: versterkte kerkelijke autonomie de staat, of beperkte deze juist de religieuze en juridische autoriteit?',
      [
        'Gallicanisme versterkte en beperkte koninklijke macht tegelijk',
        'Het Gallicanisme schafte de koninklijke religieuze autoriteit volledig af',
        'De Kerk handhaafde volledige onafhankelijkheid van staatscontrole',
        'Het Gallicanisme was een zuiver theologisch concept zonder politieke implicaties',
      ],
      0,
      'Het Gallicanisme verdedigde de Franse onafhankelijkheid van de paus, terwijl het de Kerk aan de staat onderwierp. Bisschoppen behielden echter uitzonderingen en eigen jurisdictieclaims. Dit resulteerde in een compromis: religieuze autoriteit werd aan de staat onderworpen, maar niet volledig.',
    ],
    [
      'Hoe onthulde de sociale samenstelling van de Septembermoorden (1792) — geen georganiseerde moordpartij, maar spontaan menigtegeweld — de ineenstorting van de Revolutionaire openbare orde en de opkomst van terreur als ongearticuleerde volkspraktijk?',
      [
        'Parijse menigten doodden geestelijken en adel zonder staatsleiding',
        'De Septembermoorden waren volledig door de regering georkestreerd en niet spontaan',
        'Ze hadden geen enkele verbinding met het Schrikbewind',
        'De menigten vormden een minuscule minderheid met een verwaarloosbare historische impact',
      ],
      0,
      'De Septembermoorden (meer dan 1.200 slachtoffers, gedood door menigten) gingen aan het Schrikbewind vooraf. Ze lieten zien hoe revolutionaire angst populair geweld kon aanwakkeren zonder staatsorganisatie — een voorbode van het Schrikbewind.',
    ],
    [
      'In welke mate vertegenwoordigde de Vendéeopstand (1793–1796) een tegenrevolutionaire boerenopstand versus een gecoördineerde royalistische opstand, en wat onthult het debat hierover over de politisering van het platteland?',
      [
        'Historici debatteren over een autonome opstand versus elitecoördinatie',
        'De Vendée was volledig een democratische boerenopstand zonder klassencomplexiteit',
        'Het was uitsluitend een elitesamenzwering zonder deelname van boeren',
        'De Vendée-regio was niet politiek actief tijdens de Revolutie',
      ],
      0,
      'De Vendéeopstand combineerde autonome grieven (verzet tegen dienstplicht, verdediging van de religie) met coördinatie door de elite. Deze ambiguïteit toont hoe plattelandsbevolkingen Revolutionaire actoren werden, terwijl ze tegelijk onderhevig waren aan manipulatie.',
    ],
    [
      'Hoe schiep de structurele instabiliteit van het Directoire — schommelend tussen oligarchische en democratische facties, en het onvermogen om stabiele eigendomsverhoudingen en legerloyaliteit te waarborgen — de voedingsbodem voor Napoleons coup van 18 Brumaire als rationalisering en stabilisatie?',
      [
        'Napoleon bood onstabiele oligarchen een stabiliteitsdeal.',
        'Het Directoire was zeer stabiel en kende geen crises',
        'De coup was volledig toevallig en onvoldoende gepland',
        'Het Directoire had zich makkelijk kunnen aanpassen en had zonder Napoleon kunnen overleven',
      ],
      0,
      'Factionalisering binnen het Directoire, onvoorspelbare verkiezingsuitslagen, militaire versnippering en fiscale zwakte schiepen een endemische instabiliteit. Bonaparte bood de oligarchen een ruil aan: militaire orde in ruil voor zekerheid over eigendom en handel.',
    ],
    [
      'In welke mate vormde het Napoleonisch Wetboek — met zijn codificatie van eigendomswetgeving, de afschaffing van het feodalisme en het wereldlijke burgerrecht — eerder een revolutie in de rechtsfilosofie dan louter de uitvoering van Revolutionair beleid?',
      [
        'Het Wetboek verving gewoonterecht door gepubliceerde wetten.',
        'Het Wetboek was zuiver administratief en bevatte geen filosofische innovatie',
        'Het was volledig afgeleid van het feodale recht, zonder enige verandering',
        'Juridische filosofie was irrelevant voor de totstandkoming van het Wetboek',
      ],
      0,
      'Het geschreven, gepubliceerde en systematisch geordende Wetboek verving de ondoorzichtigheid van het feodale recht en de regionale gewoonterechtvarianten. Deze verschuiving van ongeschreven gewoonterecht naar gerationaliseerde wetboeken veranderde de aard van juridische autoriteit zelf — een methodologische revolutie.',
    ],
  ],
};
